import iconGitHub from "images/icon-github.svg"
import iconTwitter from "images/icon-twitter.svg"
import iconDiscord from "images/icon-discord.svg"
import iconDocuments from "images/icon-docs.svg"

import iconGitHubLight from "images/icon-github-primary.svg"
import iconTwitterLight from "images/icon-twitter-primary.svg"
import iconDiscordLight from "images/icon-discord-primary.svg"
import iconDocumentsLight from "images/icon-docs-primary.svg"

/* terra:network */
//export const FINDER = "https://finder.terraclassic.community/mainnet"
export const FINDER = "https://finder.terraclassic.community/mainnet"
export const TERRA_STATION_EXTENSION =
  "https://chrome.google.com/webstore/detail/terra-station/aiifbnbfobpmeekipheeijimdpnlpgpp"
export const XDEFI_EXTENSION =
  "https://chrome.google.com/webstore/detail/xdefi-wallet/hmeobnfnfcmdkdcmlblgagmfpfboieaf"
export const CHROME = "https://google.com/chrome"

// Standard CW20 Info
export const CW20_NAME = "ALPHA Token"
export const CW20_SYMBOL = "ALPHA"
export const CW20_ADDR =
  "terra1x6e64es6yhauhvs3prvpdg2gkqdtfru840wgnhs935x8axr7zxkqzysuxz"
export const CW20_ICON = "https://i.ibb.co/pzhX75F/alpha-token-128.png"
export const CW20_WEBSITE = ""
export const WHITE_PAPER_URL = ""

// Front End Specific
export const SALES_ADDR =
  "terra14t6pjtm6nrrfdpm27flhput95w4cmrgp3dtp7uc94p33zsfvhmyq3eegdr"
export const STAKE_FACTORY_ADDR =
  "terra1gqwpucc90tjd7plnecxwnvxsm96u2w7x4ezkv2eqnxecg2hdj05qecs8v3"
export const STAKING_ADDR =
  "terra1v2760t2ak6knlja6xqhd254anlaqe6jusf9ync2s6hz7570q3frqmgrxge"
export const SWAP_PAGE_HEADING = "ALPHA Private Sale"
export const SWAP_PAGE_SUB_HEADING = "LUNC Universe"
export const MEMO_TITLE = "Private Sale"
export const MANAGER = "terra1ljqgc0cdkl7gcc7s64eczv3hrgga32vfh8xvfj"

// Staking Specific
export const ARBITER_ADDRESS = "terra1ljqgc0cdkl7gcc7s64eczv3hrgga32vfh8xvfj"
export const STAKING_OPTIONS = [
  ["10% (90 days)", 0],
  ["25% (180 days)", 0],
  ["30% (270 days)", 0],
  ["45% (365 days)", 0],
]

/* terra:configs */
export const BLOCK_TIME = 6650 // 6.65s

/* coin:unit */
export const MIR = "MIR"
export const UUSD = "uusd"
export const ULUNA = "uluna"
export const UKRW = "ukrw"
export const USDR = "usdr"
export const UMNT = "umnt"
export const UAUD = "uaud"
export const UCAD = "ucad"
export const UCHF = "uchf"
export const UCNY = "ucny"
export const UEUR = "ueur"
export const UGBP = "ugbp"
export const UHKD = "uhkd"
export const UINR = "uinr"
export const UJPY = "ujpy"
export const USGD = "usgd"
export const UTHB = "uthb"
export const UST = "UST"
export const KRT = "KRT"
export const SDT = "SDT"
export const MNT = "MNT"
export const LUNA = "uluna"
export const AUT = "AUT"
export const CAT = "CAT"
export const CHT = "CHT"
export const CNT = "CNT"
export const EUT = "EUT"
export const GBT = "GBT"
export const HKT = "HKT"
export const INT = "INT"
export const JPT = "JPT"
export const SGT = "SGT"
export const THT = "THT"
export const LP = "LP"

export const NATIVE_TOKENS = [
  ULUNA,
  UUSD,
  UKRW,
  USDR,
  UMNT,
  UEUR,
  UCNY,
  UJPY,
  UGBP,
  UINR,
  UCAD,
  UCHF,
  UAUD,
  USGD,
  UTHB,
  UHKD,
]

/* dApp configs */
export const DEFAULT_MAX_SPREAD = 0.5
export const MAX_MSG_LENGTH = 1024

/* network:settings */
export const TX_POLLING_INTERVAL = 1000
export const MAX_TX_POLLING_RETRY = 35
export const DEFAULT_EXT_NETWORK: ExtNetworkConfig = {
  name: "mainnet",
  chainID: "columbus-5",
  fcd: "https://terra-classic-fcd.publicnode.com",
  lcd: "https://terra-classic-lcd.publicnode.com",
}

/* project */
export const MEDIUM = ""
export const DISCORD = ""
export const TELEGRAM = ""
export const WECHAT = ""
export const GITHUB = ""

export const socialMediaList = [
  {
    icon: iconGitHub,
    iconLight: iconGitHubLight,
    href: "",
    title: "GitHub",
  },
  {
    icon: iconTwitter,
    iconLight: iconTwitterLight,
    href: "https://twitter.com/jaylea1989",
    title: "Twitter",
  },
  {
    icon: iconDiscord,
    iconLight: iconDiscordLight,
    href: "",
    title: "Discord",
  },
  {
    icon: iconDocuments,
    iconLight: iconDocumentsLight,
    href: "",
    title: "Documents",
  },
]
